<template>
  <div id="modalDiscard" class="modal fade modal-md show" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-modal="true" role="dialog" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content !rounded-[20px]">
        <div class="modal-body p-4 pb-5">
          <div class="flex flex-col gap-4 w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Select Job Service Type</h2>
              </div>
              <button class="w-[40px] h-[40px] p-2 bg-[#fff]" @click="closeModal" type="button" data-bs-dismiss="modal"
                aria-label="Close">
                <img src="@/assets/images/modal-cross-icon.png">
              </button>
            </div>
            <div>
              <p class="m-0 font-lato text-[16px] text-[#333333]">
                For this job,
              </p>
              <span class="m-0 font-lato text-[16px] text-[#333333]">
                will you perform an Evaluation (Repair) or Maintenance?
              </span>
            </div>
            <ul class="p-0 m-0 flex flex-col gap-2 my-3">
              <li v-for="(service, index) in services" :key="index">
                <label
                  class="m-0 flex items-center gap-2 p-2 rounded-[5px] cursor-pointer bg-opacity-50 border border-[#EFEFEF] bg-[#EFEFEF]">
                  <input v-model="check" :value="service.id" type="radio" class="accent-[#FE5000] ">
                  <span class="font-lato text-[#092E87]">{{ service.title }}</span>
                </label>
              </li>
            </ul>
            <div class="flex justify-center items-center gap-3">
              <span
                class="border-1 py-2 px-5 rounded-full cursor-pointer transition duration-300 text-[#092E87] border-[#092E87] hover:bg-[#092E87] hover:text-[#fff]"
                @click="confirm">Submit</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import { template } from "lodash";
const toast = useToast();

export default {
  components: {},

  data() {
    return {
      check: 1,
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "apptDetail", "services"]),
  },

  watch: {},

  mounted() { },

  methods: {
    ...mapActions(["setCommponent"]),

    editQuoteClicked() {
      this.setCommponent("QuoteItems");
    },

    closeModal() {
      this.check = 1;
      this.$emit("event", "close");
    },

    confirm() {
      this.$emit("event", "confirm", this.check);
    },
  },
};
</script>
